import React, { useCallback } from "react";
import styles from "./Style.module.css";
import { ArrowBackIos, Cached } from "@mui/icons-material";
import { Dialog, ButtonBase, Typography, DialogContent } from "@mui/material";
import {makeStyles} from "@mui/styles";
import {
  ArrowOutlineButton,
  ArrowPrimaryButton,
  OutlineButton,
  PrimaryButton,
} from "../../../components/Buttons/PrimaryButton";
import history from "../../../libs/history.utils";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import useUserQueriesDetailDetailHook from "./UserQueriesDetail.hook";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import StatusPill from "../../../components/Status/StatusPill.component";
import UpdateStatusDialog from "./UpdateStatusDialog/UpdateStatusDialog.view";
import CloseIcon from "@mui/icons-material/Close";
import useRoles from "../../../hooks/RoleHook";
import Constants from "../../../config/constants";
import RouteName from "../../../routes/Route.name";
import { removeUnderScore } from "../../../helper/Helper";

const UserQueriesDetail = () => {
  const {
    data,
    isUpdateStatusOpen,
    handleUpdateStatus,
    handleSubmit,
    renderList,
    selectedImage,
    handleImageClick,
    handleCloseDialog,
    renderStatus,
  } = useUserQueriesDetailDetailHook();
  const { canDelete, canRead, canCreate, canUpdate } = useRoles(
    Constants.MODULES.SUPPORT_REQUEST
  );
  const ComentRenderer = ({ content }) => {
    const formattedContent =
      content?.replace(/(?:\r\n|\r|\n)/g, "<br />");
    return <div dangerouslySetInnerHTML={{ __html: formattedContent }}></div>;
  };

  const renderTimeline = useCallback((status) => {
    if (status === "IN_PROGRESS") {
      return (
        <StatusPill
          status={"IN PROGRESS"}
          color={"progress"} 
          style={{background: 'transparent', marginLeft: "-12px" }}
          
         
        />
      );
    } else if (status === "PENDING") {
      return (
        <StatusPill
          status={"PENDING"}
          color={"pending"}
          style={{background: 'transparent', marginLeft: "-12px" }}
        />
      );
    } else if (status === "RESOLVED") {
      return (
        <StatusPill
          status={"RESOLVED"}
          color={"active"}
          style={{background: 'transparent', marginLeft: "-12px" }}
        />
      );
    } else if (status === "DISPOSED") {
      return (
        <StatusPill
          status={"DISPOSED"}
          color={"high"}
          style={{background: 'transparent', marginLeft: "-12px" }}
        />
      );
    }
  }, []);

  const formatText = (text) =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

  return (
    <>
      <div>
        <div className={styles.upperFlex}>
          <ButtonBase onClick={() => history.push(RouteName.USER_QUERIES)} sx={{ mb: 1 }}>
            <ArrowBackIos fontSize={"small"} />{" "}
            <span className="">
              <Typography variant={"h4"}>Complaint Detail</Typography>
            </span>
          </ButtonBase>

          {/* {(canCreate || canUpdate) && ( */}
            {/* <ArrowOutlineButton
            onClick={handleUpdateStatus}
            icon={<Cached fontSize="normal"/>}
          
          >
            UPDATE STATUS
          </ArrowOutlineButton> */}
        {/* )} */}
        </div>
     
        <div className={styles.row}>
          <ShadowBox className={`${styles.report} ${styles.title}`}>
            <div className={styles.upperFlex}>
              <div className={styles.row}>
                {console.log(data, "support")}
                <Typography
                  variant={"h5"}
                  className={styles.reportHeading}
                  color={"text.primary"}
                  sx={{ mr: 1 }}
                >
                  {" "}
                  {data?.ref_no}
                </Typography>

              </div>
              <div>{renderStatus(data?.status)}</div>
            </div>
            <div className={styles.gridContainer}>
              <div className={styles.reporterDetails}>
                <div className={styles.reportContent}>
                  <div className={styles.row}>
                    <Typography
                      variant="body1"
                      color={"text.primary"}
                      sx={{ mr: 1 }}
                      className={styles.key}
                    >
                      User Name:{" "}
                    </Typography>
                    <Typography variant="body1" color={"text.secondary"}>
                      {data?.user?.name || "N/A"}
                    </Typography>
                  </div>
                  <div className={styles.row}>
                    <Typography
                      variant="body1"
                      color={"text.primary"}
                      sx={{ mr: 1 }}
                      className={styles.key}
                    >
                      Concern:
                    </Typography>
                    <Typography variant="body1" color={"text.secondary"}>
                      {removeUnderScore(data?.concern) || "N/A"}
                    </Typography>
                  </div>
                  <div className={styles.row}>
                    <Typography
                      variant="body1"
                      color={"text.primary"}
                      sx={{ mr: 1 }}
                      className={styles.key}
                    >
                      Date of request:
                    </Typography>
                    <Typography variant="body1" color={"text.secondary"}>
                      {data?.createdAtText || "N/A"}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className={styles.patientDetails}>
                <div className={styles.reportContent}>
                <div className={styles.row}>
                    <Typography
                      variant="body1"
                      color={"text.primary"}
                      sx={{ mr: 1 }}
                      className={styles.key}
                    >
                      User Contact:
                    </Typography>
                    <Typography variant="body1" color={"text.secondary"}>
                      {data?.phone_number || "N/A"}
                    </Typography>
                  </div>
                  <div className={styles.row}>
                    <Typography
                      variant="body1"
                      color={"text.primary"}
                      sx={{ mr: 1 }}
                      className={styles.key}
                    >
                     Subject:
                    </Typography>
                    <Typography variant="body1" color={"text.secondary"}>
                      {data?.subject || "N/A"}
                    </Typography>
                  </div>
                  <div className={styles.row}>
                    <Typography
                      variant="body1"
                      color={"text.primary"}
                      sx={{ mr: 1 }}
                      className={styles.key}
                    >
                     Last Updated:
                    </Typography>
                    <Typography variant="body1" color={"text.secondary"}>
                      {data?.updatedAtText || "N/A"}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.line} />
            <Typography
              variant={"body1"}
              className={styles.reportHeading}
              color={"text.primary"}
              sx={{ mb: 1, mr: 1, mt: 2 }}
            >
              {" "}
              Event Description
            </Typography>
            <Typography variant="body1" color={"text.secondary"} sx={{ mb: 2 }}>
              {data?.description}
            </Typography>
            <Typography
              variant={"body1"}
              className={styles.reportHeading}
              color={"text.primary"}
              sx={{ mb: 1, mr: 1, mt: 2 }}
            >
              {" "}
              Attachments
            </Typography>
            <div className={styles.row}>
              {data?.images?.map((image, index) => (
                <div
                  className={styles.imageBox}
                  onClick={() => handleImageClick(image)}
                >
                  <img
                    key={index}
                    src={image}
                    alt="Image"
                    className={styles.image}
                    crossOrigin="anonymous"
                  />
                </div>
              ))}
            </div>
          </ShadowBox>
        </div>
       

        <div className={styles.container}>
          <ShadowBox className={styles.report}>
            <div className={styles.title}>
              <Typography
                variant={"h5"}
                className={styles.productHeading}
                color={"text.primary"}
                sx={{ marginTop: "-10px", mb: 1 }}
              >
                {" "}
                Responses
              </Typography>
              {data?.update_timeline?.map((item) => (
                <div className={styles.reportContent}>
                  <div>{renderTimeline(item?.status)}</div>
                  <Typography variant="body1" color={"text.primary"}>
                   <strong><ComentRenderer content={item?.comment} /></strong> 
                  </Typography>
                  <Typography
                    variant="body1"
                    color={"text.primary"}
                    sx={{ mb: 1 }}
                  >
                   
                      {item?.updated_by_name} | {item?.updatedOnText}
                   
                  </Typography>
                </div>
              ))}
            </div>
          </ShadowBox>
        </div>
      </div>

      <UpdateStatusDialog
        isUpdateStatusOpen={isUpdateStatusOpen}
        handleUpdateStatus={handleUpdateStatus}
        handleSubmit={handleSubmit}
        renderList={renderList}
      />
      <Dialog
        open={!!selectedImage}
        onClose={handleCloseDialog}
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: "9px",
          },
        }}
      >
        <div className={styles.close}>
          <CloseIcon
            onClick={() => handleCloseDialog()}
            className={styles.close}
          />
        </div>
        <DialogContent>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Selected Attachment"
              className={styles.dialogImg}
              crossOrigin="anonymous"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UserQueriesDetail;
